export default __webpack_public_path__ + "static/media/Estegosaurio.e1b4595a.png";